<div class="dashboard">
    <header>
        <section class="filters">
            <div class="filterItem periodFilter">
                <span class="text">Overview of the</span>
                <lib-generic-dropdown
                    [source]="comparisonOptions()"
                    [(selectedItem)]="filters.period"
                    (selectedItemChange)="onFilterChange()"
                    [config]="{
                        multiple: false,
                        defaultText: 'Select',
                        itemDisplayKey: 'name',
                        clearSelection: false
                    }"
                >
                </lib-generic-dropdown>
            </div>
            <div class="filterItem">
                <lib-generic-dropdown-multiselect
                    [source]="activeDepartments()"
                    [config]="{
                        multiple: true,
                        defaultText: 'Select Departments',
                        itemDisplayKey: 'name'
                    }"
                    [(selectedItems)]="filters.departments"
                    (selectedItemsChange)="onFilterChange()"
                >
                </lib-generic-dropdown-multiselect>
            </div>
            <div class="filterItem">
                <lib-generic-type-ahead-multiselect
                    [source]="salespersons()"
                    [config]="{
                        itemDisplayKey: 'fullName',
                        defaultText: 'Select Salespersons',
                        itemTemplate: itemTemplate
                    }"
                    [placeholder]="'Search Salespersons'"
                    [(selectedItems)]="filters.salespersons"
                    (textChange)="onSalespersonTextChange($event)"
                    (selectedItemsChange)="onFilterChange()"
                >
                    <ng-template #itemTemplate let-data>
                        <app-custom-menu-item
                            [inputText]="data.inputText"
                            [title]="
                                $safeNavigationMigration(data.object?.firstName) +
                                ' ' +
                                $safeNavigationMigration(data.object?.lastName)
                            "
                            [subtitle]="data.object?.email ?? ''"
                        >
                        </app-custom-menu-item>
                    </ng-template>
                </lib-generic-type-ahead-multiselect>
            </div>
        </section>

        <div class="actions">
            <button class="primary-btn" (click)="onCreateNewOpportunityClicked()">
                <span class="icon" [innerHTML]="plusIcon()"></span> New Opportunity
            </button>
        </div>
    </header>
    <section class="section">
        <div class="topSection">
            <div class="container">
                <div class="stats">
                    <app-dashboard-card>
                        @if (skeleton()) {
                            <lib-skeleton [config]="TextSkeletonConfig"></lib-skeleton>
                        }
                        @if (opportunityStat() && !skeleton()) {
                            <app-dashboard-stat
                                [title]="'New Opportunities'"
                                [previousValue]="opportunityStat()!.previousResult.opportunitiesCount"
                                [currentValue]="opportunityStat()!.currentResult.opportunitiesCount"
                            >
                            </app-dashboard-stat>
                        }
                    </app-dashboard-card>
                    <app-dashboard-card>
                        @if (skeleton()) {
                            <lib-skeleton [config]="TextSkeletonConfig"></lib-skeleton>
                        }

                        @if (opportunityStat() && !skeleton()) {
                            <app-dashboard-stat
                                [title]="'Bid Amount'"
                                [previousValue]="opportunityStat()!.previousResult.bidAmount"
                                [currentValue]="opportunityStat()!.currentResult.bidAmount"
                                [type]="'currency'"
                            >
                            </app-dashboard-stat>
                        }
                    </app-dashboard-card>
                    <app-dashboard-card>
                        @if (skeleton()) {
                            <lib-skeleton [config]="TextSkeletonConfig"></lib-skeleton>
                        }

                        @if (opportunityStat() && !skeleton()) {
                            <app-dashboard-stat
                                [title]="'Awarded Amount'"
                                [previousValue]="opportunityStat()!.previousResult.awardedAmount"
                                [currentValue]="opportunityStat()!.currentResult.awardedAmount"
                                [type]="'currency'"
                            >
                            </app-dashboard-stat>
                        }
                    </app-dashboard-card>
                    <app-dashboard-card>
                        @if (skeleton()) {
                            <lib-skeleton [config]="TextSkeletonConfig"></lib-skeleton>
                        }

                        @if (opportunityStat() && !skeleton()) {
                            <app-dashboard-stat
                                [title]="'Total Gross Margin'"
                                [previousValue]="opportunityStat()!.previousResult.totalGrossMarginPercentage"
                                [currentValue]="opportunityStat()!.currentResult.totalGrossMarginPercentage"
                                [type]="'customPercentage'"
                            >
                            </app-dashboard-stat>
                        }
                    </app-dashboard-card>
                </div>

                <div class="charts">
                    <app-dashboard-card
                        [contentType]="'chart'"
                        [icon]="infoIcon()"
                        [tooltip]="$safeNavigationMigration(salesFunnelChartConfig()?.descriptionHelpText)"
                    >
                        @if (!salesFunnelChartConfig() || skeleton()) {
                            <lib-skeleton [config]="rectangleSkeletonConfig"></lib-skeleton>
                        }

                        <app-sales-funnel-chart
                            [ngClass]="{ hidden: skeleton() }"
                            [config]="salesFunnelChartConfig()"
                        ></app-sales-funnel-chart>
                    </app-dashboard-card>

                    <app-dashboard-card
                        [contentType]="'chart'"
                        [icon]="infoIcon()"
                        [tooltip]="$safeNavigationMigration(bidVsAwardedChartConfig()?.descriptionHelpText)"
                    >
                        @if (!bidVsAwardedChartConfig() || skeleton()) {
                            <lib-skeleton [config]="rectangleSkeletonConfig"></lib-skeleton>
                        }

                        <app-bid-vs-awarded-chart
                            [ngClass]="{ hidden: skeleton() }"
                            [config]="bidVsAwardedChartConfig()"
                        ></app-bid-vs-awarded-chart>
                    </app-dashboard-card>
                </div>
            </div>
        </div>

        <div class="bottomSection">
            <div class="grids">
                <app-dashboard-opportunities-grid [type]="'upcomingBids'"></app-dashboard-opportunities-grid>
                <app-dashboard-opportunities-grid [type]="'newProjects'"></app-dashboard-opportunities-grid>
            </div>
        </div>
    </section>
</div>
